function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var rxArrIndex = /\D/;
var rxVarName = /^[a-zA-Z_$]+([\w_$]*)$/;
var rxQuot = /"/g;
function joinPaths() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }
  return paths.reduce(function (acc, p) {
    return acc ? !p || p.startsWith('[') ? "".concat(acc).concat(p) : "".concat(acc, ".").concat(p) : p;
  }, '');
}
export default function getPathToString(_) {
  function pathToString(path) {
    for (var _len2 = arguments.length, prefixes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      prefixes[_key2 - 1] = arguments[_key2];
    }
    prefixes = prefixes.filter(function (p) {
      return p !== undefined;
    });
    if (_.isString(path)) return joinPaths.apply(void 0, _toConsumableArray(prefixes).concat([path]));
    if (!Array.isArray(path)) return undefined;
    prefixes = joinPaths.apply(void 0, _toConsumableArray(prefixes));
    return path.reduce(function (acc, value) {
      var type = _typeof(value);
      if (type === 'number') {
        if (value < 0 || value % 1 !== 0) {
          return "".concat(acc, "[\"").concat(value, "\"]");
        } else {
          return "".concat(acc, "[").concat(value, "]");
        }
      } else if (type !== 'string') {
        return "".concat(acc, "[\"").concat(value, "\"]");
      } else if (!value) {
        return "".concat(acc, "[\"\"]");
      }
      if (!rxArrIndex.test(value)) {
        return "".concat(acc, "[").concat(value, "]");
      }
      if (rxVarName.test(value)) {
        if (acc) {
          return "".concat(acc, ".").concat(value);
        } else {
          return "".concat(acc).concat(value);
        }
      }
      return "".concat(acc, "[\"").concat(value.replace(rxQuot, '\\"'), "\"]");
    }, prefixes);
  }
  return pathToString;
}
getPathToString.notChainable = true;